import TDefaultEntrySidebar from './index.vue';

TDefaultEntrySidebar.install = app => {
  app.component(TDefaultEntrySidebar.name, TDefaultEntrySidebar);
};

export default TDefaultEntrySidebar;
